import { toBytes } from '../../../utils';

const isMaxFileSizeExceed = (attachedFiles, maxTotalFilesSizeMB) => {
    const maxTotalFilesSize = toBytes(maxTotalFilesSizeMB, 'MB');
    let totalFilesSize = 0;

    attachedFiles.map((file) => {
        totalFilesSize += parseInt((file.uploadedFile.content.replace(/=/g, '').length * 0.75), 10);

        return file;
    });

    return maxTotalFilesSize > 0 && totalFilesSize > maxTotalFilesSize;
};

export default isMaxFileSizeExceed;
